module.exports = __webpack_public_path__ + "img/Pic_Bg_Fz_SJDZ.6a185f67.png";